import { render, staticRenderFns } from "./contractChange.vue?vue&type=template&id=1b52793e&"
import script from "./contractChange.vue?vue&type=script&lang=js&"
export * from "./contractChange.vue?vue&type=script&lang=js&"
import style0 from "./contractChange.vue?vue&type=style&index=0&id=1b52793e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports